/* Zumpo/Filter chip. The border is 1 px in every state, so hovering or
   selecting a chip never moves the row. */
.chip {
  position: relative;
  display: inline-flex;
  flex: none;
  align-items: center;
  margin: 0;
  padding: var(--zumpo-space-8) var(--zumpo-space-16);
  border: 1px solid var(--zumpo-line);
  border-radius: var(--zumpo-radius-999);
  background: var(--zumpo-paper);
  color: var(--zumpo-ink);
  font: var(--zumpo-text-label);
  letter-spacing: var(--zumpo-text-label-tracking);
  white-space: nowrap;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

/* Drawn 38 px tall, a chip takes a tap from 44, the size a thumb needs: the
   area reaches 3 px above and below it, past the 1 px border it is placed
   inside. */
.chip::before {
  position: absolute;
  inset: calc(-1 * var(--zumpo-space-4)) calc(-1 * var(--zumpo-space-1));
  content: '';
}

@media (hover: hover) {
  .chip:hover {
    border-color: var(--zumpo-ink);
  }
}

.chip:focus-visible {
  outline: var(--focus-ring) solid var(--zumpo-ink);
  outline-offset: var(--focus-ring);
}

/* A filter chip is pressed; a chip in a Filter chip field is a checked radio. */
.chip[aria-pressed='true'],
.chip[data-checked] {
  border-color: var(--zumpo-ink);
  background: var(--zumpo-ink);
  color: var(--zumpo-cream);
}
